import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";

import { setStep, updatePerson } from "../modules/actions";
import TextInput from "./TextInput";
import DropDown from "./DropDown";
import MotivationIcon from "../assets/motivate.svg";
import { roleOptions, communityRoleOptions } from "../config";
import { shouldBeFormal } from "../util";

const Person = ({
  person,
  organization: { other_type },
  dispatch,
  orgType,
  formal,
}) => {
  const nameInput = useRef(null);

  useEffect(() => {
    if (nameInput && nameInput.current) {
      nameInput.current.focus();
    }
  }, []);

  // `role` is required for all org types except POS
  const invalid =
    person.name === "" ||
    person.email === "" ||
    person.phone === "" ||
    (orgType !== "pos" && person.role === "");

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(setStep(2));

    window.analytics?.track("Lead Form Person Step Submitted");
  };

  const roleQuestion =
    orgType === "club"
      ? "Was ist Deine Rolle im Verein?"
      : "Wie würdest du deine Rolle beschreiben?";

  return (
    <form onSubmit={handleSubmit}>
      <TextInput
        label={formal ? "Ihr Vor- und Nachname" : "Dein Vor- und Nachname"}
        value={person.name}
        onChange={({ target: { value } }) =>
          dispatch(updatePerson("name", value))
        }
        valid={person.name.length > 0}
        ref={nameInput}
      />
      {["brand", "pos"].indexOf(orgType) === -1 && (
        <DropDown
          label={roleQuestion}
          value={person.role}
          options={(
            roleOptions[orgType] ||
            roleOptions[other_type] ||
            roleOptions.default
          ).map((role) => ({ key: role, label: role }))}
          onChange={({ target: { value } }) =>
            dispatch(updatePerson("role", value))
          }
          includeBlank
        />
      )}
      <TextInput
        label={formal ? "Ihre E-Mail-Adresse" : "Deine E-Mail-Adresse?"}
        type="email"
        value={person.email}
        onChange={({ target: { value } }) =>
          dispatch(updatePerson("email", value))
        }
        valid={person.email.length > 0 && person.email.indexOf("@") > -1}
      />
      <TextInput
        label={
          formal
            ? "Unter welcher Nummer können wir Sie telefonisch erreichen?"
            : "Unter welcher Nummer können wir dich erreichen?"
        }
        value={person.phone}
        onChange={({ target: { value } }) =>
          dispatch(updatePerson("phone", value))
        }
        valid={person.phone.length > 0}
      />
      <div className="controls">
        <img src={MotivationIcon} alt="motiviation icon" />
        <button className="button" type="submit" disabled={invalid}>
          Weiter
        </button>
      </div>
    </form>
  );
};

const mapStateToProps = (state) => ({
  person: state.person,
  orgType: state.organization.type,
  formal: shouldBeFormal(state),
  organization: state.organization,
});

export default connect(mapStateToProps)(Person);
